module.exports = __webpack_public_path__ + "media/fonts/ProximaNova-Semibold-ab34565b.svg";